import Cookies from "js-cookie";
import { Button } from "react-bootstrap";
import { FaBars } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

const Navbar = ({ toggleSidebar }) => {
  const navigate = useNavigate();

  const email = Cookies.get("userEmail");
  const isParent = Cookies.get("isParent");

  const handleLogout = () => {
    const isLocalhost = window.location.hostname === "localhost";
    const domain = isLocalhost ? undefined : ".signbook.co";

    Cookies.remove("userEmail", { path: "/", domain });
    Cookies.remove("isParent", { path: "/", domain });

    localStorage.clear();
    window.location.href = "/";
  };
  const toggleFullScreen = () => {
    if (document.fullscreenEnabled) {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    }
  };
  const goToHome = () => {
    const isLocalhost = window.location.hostname === "localhost";
    window.location.href = isLocalhost
      ? "http://localhost:3035"
      : "https://signbook.co";
  };

  return (
    <div className="navbar navbar-expand-lg navbar-light shadow-sm px-3">
      <Link to="/" className="navbar-brand d-flex align-items-center">
        <img src="/assets/images/logo.png" alt="Logo" height="50" />
      </Link>

      <FaBars
        size={20}
        onClick={toggleSidebar}
        style={{ cursor: "pointer", marginLeft: "1rem" }}
      />

      <div className="ms-auto d-flex align-items-center gap-3">
        {email && <h5 className="mb-0 fw-semibold">Welcome, {email}</h5>}
        <i
          datafullscreen="true"
          className="i-Full-Screen header-icon d-none d-sm-inline-block"
          onClick={toggleFullScreen}
          style={{ cursor: "pointer", fontSize: "1.5rem" }}
        />
        <div
          className="position-relative"
          style={{ cursor: "pointer", fontSize: "1.5rem" }}
        >
          <i className="i-Bell text-muted header-icon" />
        </div>
        <Button onClick={goToHome}>Go to Home</Button>
        <Button onClick={handleLogout}>Logout</Button>
      </div>
    </div>
  );
};

export default Navbar;
